import { render, staticRenderFns } from "./ClinicItemsIncomeReport.vue?vue&type=template&id=366fcd36&scoped=true"
import script from "./ClinicItemsIncomeReport.vue?vue&type=script&lang=js"
export * from "./ClinicItemsIncomeReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366fcd36",
  null
  
)

export default component.exports